import LabelTag from './LabelTag';

export default LabelTag;
